import { useEffect, useState } from "react";
import "./FilterArea.css"
import axios from "axios";
import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select } from "@mui/material";

function FilterArea(props) {

    const [areaArray, setAreaArray] = useState([]);
    const [selectedAreaArray, setSelectedAreaArray] = useState([]);

    useEffect(() => {
        axios.get('area').then(result => {
            const sortedAreas = result.data.sort((a, b) => a.name.localeCompare(b.name));            
            setAreaArray(sortedAreas);
        })
    }, [])

    useEffect(() => {
        let idArray = [];
        selectedAreaArray.forEach((element) => {
            idArray = idArray.concat(element.assigned_employee_ids)
        })
        if (selectedAreaArray.length === 0) {
            props.setSelectedArea(null);
        } else {
            // ADDED: Pass the 'ordered_areas' so EmployeeList can sort by them
            props.setSelectedArea({ 
                "assigned_employee_ids": idArray,
                "ordered_areas": selectedAreaArray 
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedAreaArray])

    const handleSelectChange = (event) => {
        const value = event.target.value;

        // Handle "Select All"
        if (value.includes("all")) {
            if (selectedAreaArray.length === areaArray.length) {
                setSelectedAreaArray([]);
            } else {
                setSelectedAreaArray(areaArray);
            }
            return;
        }

        // --- NEW LOGIC: Preserve chronological selection order ---
        const newSelection = [];
        
        // 1. Keep currently selected items that are still checked (maintains their order)
        selectedAreaArray.forEach(area => {
            if (value.some(v => v.id === area.id)) {
                newSelection.push(area);
            }
        });

        // 2. Append newly checked items to the end
        value.forEach(newArea => {
            if (!selectedAreaArray.some(v => v.id === newArea.id)) {
                newSelection.push(newArea);
            }
        });

        setSelectedAreaArray(newSelection);
    };

    return (
        <div className="filter-area-container">
            <FormControl fullWidth size="small">
                <InputLabel>Bereich</InputLabel>
                <Select
                    multiple
                    value={selectedAreaArray}
                    label="Bereich"
                    onChange={handleSelectChange}
                    input={<OutlinedInput label="Bereiche" />}
                    renderValue={(selected) => selected.map(area => area.name).join(", ")}
                >
                    <MenuItem value="all">
                        <Checkbox checked={areaArray.length > 0 && selectedAreaArray.length === areaArray.length} />
                        <ListItemText primary="Alle auswählen" />
                    </MenuItem>
                    
                    {areaArray.map((area) => (
                        <MenuItem value={area} key={area.id || area.name}> 
                            <Checkbox checked={selectedAreaArray.some(element => element.id === area.id)} />
                            <ListItemText primary={area.name} />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    )
}

export default FilterArea;